import { SCREEN_NAMES, PRODUCT_AREA } from '@leagueplatform/analytics';

export const screenDetails = {
  screen_name: SCREEN_NAMES.FEATURE_HIGHLIGHT,
  product_area: PRODUCT_AREA.ONBOARDING,
};
